import Reveal from "@/components/Reveal";

const IMPACTS = [
  {
    tag: "Medical Affairs",
    desc: "Patient-centered insights for scientific exchange, congress strategy, MSL engagement, and evidence planning.",
  },
  {
    tag: "Market Access & HEOR",
    desc: "Patient-relevant evidence supporting value demonstration, payer engagement, and HTA discussions.",
  },
  {
    tag: "Patient Engagement",
    desc: "Advocacy, education, and support initiatives grounded in real-world patient experience.",
  },
  {
    tag: "Brand & Commercial",
    desc: "Insights into unmet need, treatment experience, adherence, and patient-centered positioning.",
  },
];

export default function PracticeImpact() {
  return (
    <section
      className="bg-ink-1 relative border-t border-white/[0.06]"
      data-testid="practice-impact-section"
    >
      <div className="container-edge py-24 lg:py-32">
        <div className="grid grid-cols-12 gap-8 items-end">
          <Reveal className="col-span-12 lg:col-span-7">
            <div className="eyebrow">Where Voice2Evidence creates impact</div>
            <h2 className="font-serif font-normal text-3xl md:text-5xl lg:text-[3.5rem] tracking-tight mt-4 text-parchment-bright max-w-3xl leading-[1.05]">
              Patient voice, translated for the functions that shape strategy.
            </h2>
          </Reveal>
          <Reveal className="col-span-12 lg:col-span-5">
            <p className="text-parchment/75 text-[15.5px] leading-relaxed">
              Patient voice is translated into evidence and strategy for the functions that shape launch, access, medical engagement, and brand growth.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/[0.08] border border-white/[0.08]">
          {IMPACTS.map((it, i) => (
            <Reveal
              key={it.tag}
              delay={i * 70}
              className="bg-ink-2 p-7 card-dark-hover flex flex-col"
              data-testid={`impact-${it.tag.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
            >
              <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-rust mb-4">
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="font-serif text-[1.4rem] text-parchment-bright leading-snug min-h-[3.5rem]">
                {it.tag}
              </h3>
              <p className="mt-4 text-[13.5px] text-parchment/70 leading-relaxed flex-1">{it.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
